import { render, staticRenderFns } from "./NoOrganisation.vue?vue&type=template&id=42c4af40&scoped=true&"
import script from "./NoOrganisation.vue?vue&type=script&lang=js&"
export * from "./NoOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./NoOrganisation.vue?vue&type=style&index=0&id=42c4af40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c4af40",
  null
  
)

export default component.exports